import './App.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import useAuthStore from './store/useAuthStore';
import { ToasterProvider } from './shared/utils/ToasterProvider';
import ClearAllStoresOnNavigate from './shared/utils/ClearAllStoresOnNavigate';
import { Box, CircularProgress } from '@mui/material';

import { useFCM } from './shared/hooks/useFCM';
import { useSocket } from './shared/hooks/useSocket';
import { useSyncUser } from './shared/hooks/useSyncUser';
import { getRoleConfig } from './config/roleConfig';

function App() {
  const { user } = useAuthStore();
  const { userDetail, isLoading } = useSyncUser();

  useFCM();
  useSocket(user?.id);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  const roleConfigs = getRoleConfig(user, userDetail);
  const normalizedRole = user?.role?.replaceAll("_", " ");
  console.log("🔍 Normalized Role:", normalizedRole);
  const config = roleConfigs[normalizedRole];




  if (!config) return null;

  const { menu, routes, layout: Layout, profile, edit } = config;
  const redirectPath = routes?.[0]?.path || '/';

  return (
    <>
      <ToastContainer />
      <ClearAllStoresOnNavigate />
      <ToasterProvider>
        <Layout menuLists={menu} editComponent={edit} profileDetail={profile}>
          <Routes>
            <Route path="/" element={<Navigate to={redirectPath} replace />} />
            {routes.map((item) => (
              <Route key={item.path} path={item.path} element={<item.Component />} />
            ))}
          </Routes>
        </Layout>
      </ToasterProvider>
    </>
  );
}

export default App;
